import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import AboutPage from "../Pages/AboutPage";
import HomePage from "../Pages/HomePage";
import MediaPage from "../Pages/MediaPage";
import SheetmusicPage from "../Pages/SheetmusicPage";

function AppRouter() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="/sheetmusic" element={<SheetmusicPage />} />
        <Route path="/media" element={<MediaPage />} />
        <Route path="/about" element={<AboutPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default AppRouter;
